// Testers recommended when a customer tries to enquire with a tester who has
// enquiries turned off. Ordered by preference: the first has the best chance of
// being shown, the last the least.
export const FAST_REPLY_TESTERS = [
  { listingId: '66bcf36e-65cf-4183-a266-7bfe89f21af1', name: 'Jennifer', replyHours: 2 },
  { listingId: '67e84921-1142-4251-a744-94f4dd0473a5', name: 'Zynndaya', replyHours: 2 },
  { listingId: '65d3cab3-8cfa-4590-a980-fa065631b688', name: 'Yourbestie_Kait', replyHours: 5 },
  { listingId: '6911365c-71a2-42c0-a8ed-fdd258635c6e', name: 'luvgiuli', replyHours: 3 },
  { listingId: '6a78ea63-14a4-4974-a97d-c6a67769b399', name: 'Katherine', replyHours: 3 },
  { listingId: '64fb6375-e423-49be-bd4c-683270492285', name: 'Ari_Loyaltytest', replyHours: 6 },
  { listingId: '6845a1dc-fcdd-43db-865b-7ea9c768ee8a', name: 'NotYourSideChick', replyHours: 7 },
  { listingId: '6534a04f-e77b-42f7-b213-a87a7a6cbf5b', name: 'Reinaaxo', replyHours: 4 },
];

export const FAST_REPLY_PICK_COUNT = 3;

// Weighted draw without replacement. With n testers the first has weight n, the
// second n - 1, and so on down to 1, so earlier testers show up more often but
// every tester gets a turn.
export const pickFastReplyTesters = (
  testers,
  count = FAST_REPLY_PICK_COUNT,
  random = Math.random
) => {
  const pool = testers.map((tester, i) => ({ tester, weight: testers.length - i }));
  const picks = [];

  while (picks.length < count && pool.length > 0) {
    const totalWeight = pool.reduce((sum, entry) => sum + entry.weight, 0);
    let roll = random() * totalWeight;
    const index = pool.findIndex(entry => {
      roll -= entry.weight;
      return roll < 0;
    });
    const [picked] = pool.splice(index === -1 ? pool.length - 1 : index, 1);
    picks.push(picked.tester);
  }

  return picks;
};
